<template>
    <div class="bs-container">
        <!--数据源查看-->
        <div class="inner-container">
            <el-form :inline="true" class="filter-container">
                <el-form-item label="数据源名称：" class="filter-input filter-item">
                    <el-input v-model="searchForm.name" class="bs-el-input" placeholder="请输入数据源名称" clearable maxlength="200"
                        @clear="searchData" />
                </el-form-item>
                <el-form-item label="所属企业：" prop="enterprise">
                    <el-select v-model="searchForm.enterprise" placeholder="">
                        <el-option-group v-for="(group, index) in options" :key="index" :label="group.label">
                            <el-option v-for="(item, index) in group.options" :key="index" :label="item.enterprise_name"
                                :value="item.enterprise_id">
                            </el-option>
                        </el-option-group>
                    </el-select>
                </el-form-item>
                <el-form-item class="filter-item">
                    <el-button type="primary" size="mini" :loading="searchLoading" icon="el-icon-search"
                        @click="searchData">
                        查询
                    </el-button>
                </el-form-item>
                <el-form-item class="filter-item">
                    <el-button class="bs-el-button-default" size="mini" @click="addSource">
                        新增
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="dataroom-table-box">
                <el-table border :height="tabmaxheight" :stripe="true" v-loading="searchLoading"
                    element-loading-text="数据正在加载中" :data="dataSourceList" @current-change="handleCurrentChange"
                    element-loading-spinner="el-icon-loading" :header-cell-style="{ background: '#eee', color: '#606266' }"
                    :highlight-current-row="true">
                    <el-empty slot="empty" />
                    <el-table-column prop="name" label="数据源名称" show-overflow-tooltip style="width: 100px;">
                        <template slot-scope="scope">
                            <el-radio v-if="isDialog" v-model="curRow" :label="scope.row">
                                {{ scope.row.name }}
                            </el-radio>
                            <span v-else>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ip" label="IP地址" show-overflow-tooltip width="120" />
                    <el-table-column prop="port" label="端口" show-overflow-tooltip width="80" />
                    <el-table-column prop="typeName" label="类型" show-overflow-tooltip width="80" />
                    <el-table-column prop="enterpriseName" label="所属企业" show-overflow-tooltip width="150" />
                    <el-table-column prop="description" label="备注" show-overflow-tooltip width="*" />
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button type="text" class="bs-el-button-default" size="mini"
                                @click="sourceLinkTest(scope.row)">
                                测试
                            </el-button>
                            <el-button type="text" class="bs-el-button-default" size="mini"
                                :disabled="scope.row.editable == 1" @click="viewSource(scope.row, 1)">
                                编辑
                            </el-button>
                            <el-button type="text" class="bs-el-button-default" size="mini"
                                :disabled="scope.row.editable == 1" @click="viewSource(scope.row, 2)">
                                配置数据库
                            </el-button>
                            <el-button type="text" class="bs-el-button-default" size="mini"
                                :disabled="scope.row.editable == 1" @click="handleDelete(scope.row)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="cr_footer">
                <div class="footer_left">
                </div>
                <div class="footer_right">
                    <el-pagination class="bs-el-pagination" popper-class="bs-el-pagination" :current-page="current"
                        :page-sizes="[10, 20, 50, 100]" :page-size="size" :total="totalCount" background prev-text="上一页"
                        next-text="下一页" layout="total, prev, pager, next,sizes" @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle" />
                </div>
            </div>
        </div>
        <!-- 数据源新增/编辑 -->
        <set-datasource ref="setDatasource" @refreshTable="init" />
        <check-datasource ref="checkDatasource" :reason-list="reasonList" />
    </div>
</template>

<script>
import resizeTableHeight from '@/components/data-room-ui/packages/assets/js/utils/resizeHeightDirevtive.js'
import SetDatasource from '@/components/data-room-ui/packages/datasource/components/SetDatasource.vue'
import CheckDatasource from '@/components/data-room-ui/packages/datasource/components/CheckDatasource.vue'
import cloneDeep from 'lodash/cloneDeep'
import { pageMixin } from '@/components/data-room-ui/packages/assets/js/mixins/page.js'
export default {
    name: 'DataSource',
    directives: {
        resizeTableHeight // 注册自定义指令
    },
    components: {
        SetDatasource,
        CheckDatasource
    },
    // 路由守卫-离开页面
    beforeRouteLeave(to, from, next) {
        const layoutEl = document.querySelector('.big-screen-router-view-wrap')
        if (layoutEl) {
            layoutEl.style.paddingLeft = '0'
        }
        next()
    },
    // 路由进入页面
    beforeRouteEnter(to, from, next) {
        const layoutEl = document.querySelector('.big-screen-router-view-wrap')
        if (layoutEl) {
            layoutEl.style.paddingLeft = '0px'
        }
        next()
    },
    mixins: [pageMixin],
    props: {
        isDialog: {
            type: Boolean,
            default: false
        },
        sourceId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            tabmaxheight: window.innerHeight - 268,
            reasonList: [],
            loadingText: '',
            deling: false,
            searchLoading: false,
            dataSourceList: [],
            searchForm: {
                name: '',
                enterprise: localStorage.getItem('enterprise_id')
            },
            size: 10,
            current: 1,
            options: JSON.parse(localStorage.getItem('entinfolist')),
            curRow: null
        }
    },
    created() { },
    mounted() {
        this.init()
        const layoutEl = document.querySelector('.big-screen-router-view-wrap')
        if (layoutEl) {
            layoutEl.style.paddingLeft = '0px'
        }
        window.addEventListener("resize", this.calculateTableHeight);
    },
    methods: {
        calculateTableHeight() {
            // 根据视图高度计算表格高度的逻辑
            this.tabmaxheight = window.innerHeight - 268; // 示例：表格高度为窗口高度减去

            //.tabwidth = window.innerWidth - 290 + "px";
        },
        // 获取当前选择数据集id
        getSourceId() {
            if (!this.isDialog) return
            if (this.curRow) {
                return this.curRow.id
            } else {
                return null
            }
        },
        // 单选数据集
        handleCurrentChange(currentRow) {
            this.curRow = currentRow
        },
        // 分页操作
        sizeChangeHandle(news) {
            this.size = news
            this.getDataList()
        },
        currentChangeHandle(newss) {
            this.current = newss
            this.getDataList()
        },
        // 查询数据
        searchData() {
            this.searchLoading = true
            this.loadingText = '正在查询数据...'
            // 重置current
            this.current = 1
            this.getDataList()
        },
        init() {
            this.current = 1
            this.getDataList()
        },
        getDataList() {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.dataSourcelist, {
                    data: {
                        enterprise_id: localStorage.getItem('enterprise_id'),
                        page: this.current,
                        limit: this.size,
                        name: this.searchForm.sourceName,
                    }
                }
                )
                .then((res) => {
                    if (res.data.code == 0) {
                        this.totalCount = res.data.data.total
                        this.dataSourceList = res.data.data.data
                        this.searchLoading = false
                    }
                })
                .catch((err) => {

                });
        },
        addSource() {
            this.$refs.setDatasource.setDatasourceVisible = true
            this.$refs.setDatasource.title = '新建数据源'
            this.$refs.setDatasource.init()
        },
        viewSource(row, type) {
            this.$refs.setDatasource.setDatasourceVisible = true
            if (type == 1) {
                this.$refs.setDatasource.title = '编辑数据源'
            } else {
                 this.$refs.setDatasource.title = '配置数据库'
            }

            this.$refs.setDatasource.init(cloneDeep(row),type)
        },
        handleDelete(row) {
            this.$MessageBox.confirm('确定删除当前数据源吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'bs-el-message-box'
            }).then(() => {
                this.$tools
                    .asyncPost(
                        this,
                        this.$baseUrl.dataSourcedel, {
                        data: {
                            ids: Array(row.id),
                        }
                    }
                    )
                    .then((res) => {
                        if (res.data.code == 0) {
                            this.$message({
                                type:'success',
                                message: '删除成功!'
                            })
                            this.init()
                        } else {
                            this.$message({
                                type: 'error',
                                message: '删除失败!'
                            })
                        }
                    })
                    .catch((err) => {
                    });
            })
        },
        sourceLinkTest(row) {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.testConnection, {
                    data: {
                        type: row.type,
                        ip: row.ip,
                        port: row.port,
                        username: row.username,
                        password: row.password,
                    }
                }
                )
                .then((res) => {
                    if (res.data.code == 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        })
                        this.init()
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
                .catch((err) => {
                });
        }
    }
}
</script>

<style lang="scss" scoped>
@import './assets/css/index.scss';
@import "../assets/style/common.scss";

.cr_footer {
    width: 100%;
    background: rgb(255, 255, 255);
    position: fixed;
    bottom: 0px;
    display: flex;
    justify-content: space-between;
    z-index: 99;
    border-top: 1px solid rgb(240, 240, 240);
    border-left: 1px solid rgb(240, 240, 240);
    margin-left: -5px;
}

.footer_left {
    width: 50%;
    text-align: left;
    display: flex;
    align-items: center;
}

.footer_right {
    width: 50%;
    text-align: right;
    padding-right: 90px;
}
</style>
